<template>
  <div>
    <section class="center padding">
      <div class="margin-bottom max-width-m">
        <h3>About WP Generator</h3>
      </div>

      <div class="container-fluid p-0">
        <div class="row no-gutter justify-content-center">
          <div class="col-md-7">
            <div class="form-wpgen text-left">
              <p class="lead mb-10">
                What is WP Generator?
              </p>

              <p class="paragraph text-justify">
                WP Generator is a plugin generator for WordPress. With the
                extensive interface the user can generate the base code for a
                WordPress plugin that works instantly. The following parts can
                be generated by WP Generator: admin panel, table schema, crud,
                rest api and many more. When the plugin is complete, you can
                download it as a zipfile. I built WP Generator on the basis of
                developer need.
              </p>

              <br />

              <p class="lead mb-10">
                The philosophy behind WP Generator
              </p>

              <p class="paragraph">
                First and foremost WP Generator is meant to save time when
                creating new plugin, in order to speed up the amount of plugins
                available for WordPress and to encourage innovation for newer
                functionalities. Secondly, I hope WP Generator aids you in
                improving your code. The real-time source code reviewer enables
                you to detect which files and codes are generated for the chosen
                parts. In case you are for example, not quite sure what is
                required to create rest api configuration fields, WP Generator
                will show you the minimum required files and parts when
                generating a rest api configuration file.
              </p>

              <router-link to="/privacy-policy">Privacy Policy</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.paragraph {
  font-size: 15px;
}
</style>
